'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _parseFloat = require('babel-runtime/core-js/number/parse-float');

var _parseFloat2 = _interopRequireDefault(_parseFloat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbStripKlantbeoordelingSamenvattingV1.$inject = ['$http', '$q', 'XmlToJsonService', 'EnvironmentService'];
var _module = angular.module('cb.strips.cbStripKlantbeoordelingSamenvattingV1', []);

_module.directive('cbStripKlantbeoordelingSamenvattingV1', cbStripKlantbeoordelingSamenvattingV1);

exports.default = _module;


function cbStripKlantbeoordelingSamenvattingV1($http, $q, XmlToJsonService, EnvironmentService) {
    cbStripKlantbeoordelingReviewnavigatorV1Controller.$inject = ['$scope', 'XmlToJsonService'];

    return {
        restrict: 'A',
        controller: cbStripKlantbeoordelingReviewnavigatorV1Controller
    };

    function cbStripKlantbeoordelingReviewnavigatorV1Controller($scope, XmlToJsonService) {
        var version = 1.00;
        // define two xml urls, and use a dummy if we are currently working in development environment
        var dummyXML = '/assets/mobilefirst/xml/company-reviews-dummy.xml';
        var reviewXML = '/assets/xml/company-reviews.xml';
        var xmlUrl = EnvironmentService.isDevelopment() ? dummyXML : reviewXML;
        var jsonData = void 0;

        getReviewXML(xmlUrl).then(function (result) {
            jsonData = XmlToJsonService.convert(result);
            var data = jsonData.default;
            var reviews = formatReviews(data.review_list.review);

            var amountOfReviews = reviews.length;
            var calculatedTotalScore = reviews.reduce(function (acc, cur) {
                return acc + (0, _parseFloat2.default)(cur.totalScore);
            }, 0) / amountOfReviews;
            var formattedTotalScore = calculatedTotalScore < 10 ? calculatedTotalScore.toFixed(1).toString().replace('.', ',') : calculatedTotalScore;

            $scope.calculatedTotalScore = formattedTotalScore;
            $scope.amountOfReviews = amountOfReviews;
        });
    }

    function formatReviews(reviews) {
        return reviews.map(function (review) {
            return {
                totalScore: review.total_score
            };
        });
    }

    function getReviewXML(url) {
        var reviews = $q.defer();

        $http({
            method: 'GET',
            url: url
        }).then(function successCallback(response) {
            var xml = new window.DOMParser().parseFromString(response.data, 'text/xml');
            reviews.resolve(xml);
        }, function errorCallback(response) {
            reviews.reject(response.status);
        });

        return reviews.promise;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/klantbeoordeling-samenvatting-v1/klantbeoordeling-samenvatting.directive.js
// module id = 950
// module chunks = 1